/* eslint-disable camelcase */
import Socket from '../connection/socket';
import { getState, socketListenerDispatch } from './socket-listener-main';
import { getShowSessions } from '../stores/actions/session';
import { GreenroomState } from '../stores/types/types';

function handleShowSessionsUpdate(message: any) {
	if (message
		&& message.message
		&& message.message.token
		&& message.message.meeting) {
		socketListenerDispatch(getShowSessions(message.token, message.message.meeting));
	}
}

function handleSettingsQueue(message: any) {
	const { SessionReducer: { session } } = getState() as GreenroomState;
	const { action, from } = message.message;

	if (from !== session) {
		socketListenerDispatch({ ...action, remote: true });
	}
}

export default function HostSync(socket: Socket) {
	socket.addListener('show-sessions-update', handleShowSessionsUpdate);
	socket.addListener('settings-sync', handleSettingsQueue);
}
